import { request } from 'Lib/agent';

export const getGenerativeText = (data, params) => {
    return request.post(`ai/generative/text`, data, params);
};

export const rateGenerativeText = (id, data, params) => {
    return request.post(`/ai/statistics/${id}/rate`, data, params);
};
